module.exports = __webpack_public_path__ + "static/media/11.d3e9677f.mp3";